import React, { Component } from "react";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2/dist/sweetalert2.js";
import FormCreateShow from "./FormCreateShow";
import Chart from "../../../GeneralComponents/Charts/ChartNormativity";
import RkHeader from "../../../GeneralComponents/RkHeader";
import Preloader from '../../../GeneralComponents/LoadingComponen'
import Comments from "../../../GeneralComponents/Comments"

class Show extends Component {
  constructor(props) {
    const date = new Date();
    super(props);
    // getMonth() cuenta desde 0: sin el +1 la evaluación nueva se guardaba con un mes menos
    this.fecha = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`
    this.token = document.querySelector("[name='csrf-token']").content;
    this.state = {
      data: this.props.califications,
      modal: false,
      modeEdit: false,
      accion: {},
      id: "",

      formValuesComments: {
        comment: "",
        module_name: this.props.nameModule,
        normativity_score_id: "",
      },

      formValues : {
        date_score: this.fecha,
        normativity_id: this.props.normativity.id,
        responsible_user_id: "",
        user_ids: []
      },

      selectedOption: {
        responsible_user_id: "",
        label: "Seleccionar"
      },

      users: [],
      dataCommets: [],
      editValues: [],
    };
    
  }

  componentDidMount(){
    // `data` (las evaluaciones) llega ASÍNCRONO desde el pack (fetch). Si ya está
    // presente al montar, enlazamos los comentarios de una vez; si no, lo hace
    // componentDidUpdate cuando llegue.
    this.bindCommentsToScore();

    let array = []

    this.props.users.map((item) => (
      array.push({label: item.name, value: item.id})
    ))

    this.setState({
        users: array
    })
  }

  componentDidUpdate(prevProps){
    // Cuando llega la primera evaluación (data pasa de vacío a tener datos),
    // enlazamos los comentarios a esa evaluación y los cargamos.
    const prevLen = (prevProps.data || []).length;
    const currLen = (this.props.data || []).length;
    if (prevLen === 0 && currLen > 0) {
      this.bindCommentsToScore();
    }
  }

  // Enlaza el formulario de comentarios a la evaluación actual (data[0]) y los carga.
  // Idempotente: solo actúa una vez, cuando hay evaluación y aún no se enlazó.
  bindCommentsToScore = () => {
    if (this.props.data && this.props.data.length > 0 && !this.state.formValuesComments.normativity_score_id) {
      this.setState({
        formValuesComments: {
          ...this.state.formValuesComments,
          normativity_score_id: this.props.data[0].id,
        },
      });
      this.loadDataComments();
    }
  }

  handleChangeAutocomplete = selectedOption => {
    this.setState({
      selectedOption,
      formValues: {
        ...this.state.formValues,
        responsible_user_id: selectedOption.value
      }
    });
  };

  messageSuccess = (response) => {
    Swal.fire({
      position: "center",
      type: "success",
      title: `${response.success}`,
      showConfirmButton: false,
      timer: 1500,
    });
  };

  clearValues = () => {
    this.setState({
      modal: false,
      modeEdit: false,
      id: "",
      formValues: {
        date_score: this.fecha,
        normativity_id: this.props.normativity.id,
        responsible_user_id: "",
        user_ids: []
      },

      selectedOption: {
        responsible_user_id: "",
        label: "Seleccionar"
      },

      editValues: [],

    });
  };

  onChangeForm = (e) => {
    this.setState({
      formValues: {
        ...this.state.formValues,
        [e.target.name]: e.target.value,
      },
    });
  };


  toogle = (from) => {
    if(from == "new"){
      this.setState({ modal: true, titleForm: "Agregar Numeral",})
    }else{
      this.setState({ modal: false})
      this.clearValues()

    }
  }

  handleChangeAutocompleteUsers = selectedOption => {
    let array = []

    selectedOption.map((item) => (
      array.push(item.value)
    ))

    this.setState({
      formValues: {
        ...this.state.formValues,
        user_ids: array
      }
    })
  };

  HandleClick = (e) => {
    if (this.state.modeEdit == true) {
      fetch("/health/normativity_scores/" + this.state.id, {
        method: "PATCH", // or 'PUT'
        body: JSON.stringify(this.state.formValues), // data can be `string` or {object}!
        headers: {
          "X-CSRF-Token": this.token,
          "Content-Type": "application/json"
        },
      })
        .then((res) => res.json())
        .catch((error) => console.error("Error:", error))
        .then((response) => {
          this.messageSuccess(response);
          this.props.loadData();
          this.clearValues();
        });
    } else {
      this.props.updateStateLoad(true)
      fetch("/health/normativity_scores", {
        method: "POST", // or 'PUT'
        body: JSON.stringify(this.state.formValues), // data can be `string` or {object}!
        headers: {
          "X-CSRF-Token": this.token,
          "Content-Type": "application/json"
        },
      })
        .then((res) => res.json())
        .catch((error) => console.error("Error:", error))
        .then((response) => {
          this.messageSuccess(response);
          this.props.loadData();
          this.props.updateStateLoad(false)
          this.clearValues();
        });
    }
  };

  toggle = (show, register) => {
    if (show == "open") {
      this.setState({
        modal: true,
        modeEdit: true,
        accion: register,
        formValues: {
          date_score: this.fecha,
          normativity_id: this.props.normativity.id,
          responsible_user_id: "",
        },
      });
    } else {
      this.clearValues();
    }
  };

  editCalification = (calification) => {
    let arrayUsers = []

    calification.users.map((item) => (
      arrayUsers.push({label: `${item.first_name} ${item.first_last_name}`, value: item.id})
    ))
  
    this.setState({
      modal: true,
      id: calification.id,
      modeEdit: true,
      formValues: {
        ...this.state.formValues,
        responsible_user_id: calification.responsible_user_id,
        date_score: calification.date_score,
      },

      selectedOption: {
        responsible_user_id: calification.responsible_user_id,
        label: `${calification.responsible_user.first_name} ${calification.responsible_user.first_last_name}`
      },

      editValues: arrayUsers

    })
  }

  delete = id => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "¡El registro será eliminado para siempre!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#009688",
      cancelButtonColor: "#d33",
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar"
    }).then(result => {
      if (result.value) {
        fetch(`/health/normativity_scores/${id}`, {
          method: "delete",
          headers: {
            "X-CSRF-Token": this.token,
            "Content-Type": "application/json"
          }
        })
          .then(response => response.json())
          .then(response => {
            this.props.loadData();
            this.messageSuccess(response)
          });
      }
    });
  };

  getColor(value){
    let color = ""
    if (value < 6){
    color = "#ea4612"
    }else if (value >= 6 && value < 8){
        color = "orange";
    }
    else{
        color = "#30af28"
    }
    return color
  } 


  //cometarios

  loadDataComments = () => {
    fetch(`/get_general_commets_normativity/${this.props.data[0].id}`, {
        method: 'GET', // or 'PUT'
        headers: {
            "X-CSRF-Token": this.token,
            "Content-Type": "application/json"
        }
    })
    .then(response => response.json())
    .then(data => {
      this.setState({
        dataCommets: data.data,
      });
    });
  }

  HandleChangeComment = (e) => {
    this.setState({
        formValuesComments: {
          ...this.state.formValuesComments,
          comment: e.target.value
        }
    });
  }

  clearValuesComment = () => {
    this.setState({
        formValuesComments: {
          ...this.state.formValuesComments,
          comment: ""
        }
    });
  }


  getBack = (value) => {
    let url = "/health/normativity?type=" + this.props.normativity.type
    Turbolinks.visit(value, "_self")
}


getNameTitle = (name) => {
    if (typeof window !== "undefined" && window.GS_TYPE_NAMES && window.GS_TYPE_NAMES[name]) {
        return window.GS_TYPE_NAMES[name];
    }
    if(name == "PCH" || name == "NMH"){
        return "Hospitales"
    }else if(name == "PCCAP"){
        return "Modelo Ambulatorio"
    }else if(name == "PCISO9001"){
        return "ISO 9001:2015 Salud"
    }else if(name == "PCISO15189"){
        return "ISO 7101:2023 HQM"
    }else if(name == "PCHEM"){
        return "Acreditación"
    }else if(name == "NCON"){
        return "Servicios Auxiliares"
    }else if(name == "NFAR"){
        return "Expediente Clínico"
    }else if(name == "NNOM"){
        return "Marco Legal"
    }
}

  render() {
    return (
      <React.Fragment>
        <FormCreateShow
          toggle={this.toggle}
          backdrop={"static"}
          modal={this.state.modal}
          onChangeForm={this.onChangeForm}
          formValues={this.state.formValues}
          submitForm={this.HandleClick}
          nameSubmit={
            this.state.modeEdit == true ? "Actualizar" : "Crear calificación"
          }

          title={this.state.modeEdit == true ? "Actualizar calificación" : "Crear Nueva calificación"}

          //autocomplete

          users={this.state.users}
          formAutocomplete={this.state.selectedOption}
          onChangeAutocomplete={this.handleChangeAutocomplete}

          //is_loading
          isLoaded={this.props.isLoaded}

          //autocomplete users
          handleChangeAutocompleteUsers={this.handleChangeAutocompleteUsers}
          editValues={this.state.editValues}

          showAddUsers={true}

        />

        <RkHeader
            title={"Evaluaciones de " + this.props.normativity.name}
            subtitle={this.props.normativity.description}
            titleNew={"Nueva evaluación"}
            icon="fas fa-clipboard-check"
            onClickNew={this.toogle}
            showNew={this.props.estados.crear}
            showFilter={false}
        />

        <div className="rk-wrap">
          <nav aria-label="breadcrumb">
            <div className="rk-breadcrumb">
              <a href="javascript:void(0);" onClick={() => this.getBack(`/health/normativity?type=${this.props.normativity.type}`)}>
                <i className="fas fa-hospital"></i> {this.getNameTitle(this.props.normativity.type)}
              </a>
              <span className="rk-breadcrumb__sep">/</span>
              <a href="javascript:void(0);" onClick={() => this.getBack(`/health/normativity/${this.props.normativity.id}/numeral_parents`)}>
                Estándares y Guías
              </a>
              <span className="rk-breadcrumb__sep">/</span>
              <span className="rk-breadcrumb__current">Evaluaciones de {this.props.normativity.name}</span>
            </div>
          </nav>

          {!this.props.isLoaded ? (
            this.props.data.length >= 1 ? (
              <React.Fragment>
                {this.props.loadCalifications == true ? (
                  <Preloader />
                ) : (
                  <div className="row">
                    <div className="col-md-4 mb-4">
                      <div className="rk-gestion__info">
                        <div className="rk-meta" style={{ paddingTop: 0, borderTop: "none", marginBottom: "14px" }}>
                          <div>
                            <span className="rk-meta__label">Última calificación</span>
                            <span className="rk-meta__chip">{this.props.data[0].date_score}</span>
                          </div>
                        </div>

                        <div className="rk-npr-grid" style={{ gridTemplateColumns: "1fr", marginBottom: "14px" }}>
                          <div className="rk-npr rk-npr--npr">
                            <div className="rk-npr__label">Nota de cumplimiento</div>
                            <div
                              className="rk-npr__value"
                              style={{ color: this.getColor(this.props.data[0].score != null ? this.props.data[0].score : 0) }}
                            >
                              {this.props.data[0].score != null ? this.props.data[0].score : 0}
                            </div>
                          </div>
                        </div>

                        <div className="rk-meta">
                          <div>
                            <span className="rk-meta__label">Gestores</span>
                          </div>
                          <ul style={{ margin: 0, paddingLeft: "18px" }}>
                            {this.props.data[0].users.map((user, index) =>
                              <li key={index}>{user.first_name} {user.first_last_name}</li>
                            )}
                          </ul>
                        </div>

                        <div className="rk-inline-actions" style={{ justifyContent: "center", marginTop: "18px", flexWrap: "wrap", gap: "8px" }}>
                          {/* Califican los gestores, el responsable y quien puede editar evaluaciones (incluye al Administrador Sistema) */}
                          {(this.props.data[0].users.filter(user => user.id == this.props.current_user.id).length >= 1 || this.props.data[0].responsible_user_id == this.props.current_user.id || this.props.estados.editar) && (
                            <a
                              href={`/health/normativity_scores/${this.props.data[0].id}`}
                              className="rk-btn rk-btn--primary"
                              data-turbolinks="true"
                            >
                              <i className="ion-ios-analytics-outline"></i> Gestionar Evaluación
                            </a>
                          )}

                          {this.props.estados.editar && (
                            <button
                              type="button"
                              className="rk-icon-btn"
                              title="Editar"
                              onClick={() => this.editCalification(this.props.data[0])}
                            >
                              <i className="fas fa-pencil-alt"></i>
                            </button>
                          )}

                          {this.props.estados.eliminar && (
                            <button
                              type="button"
                              className="rk-icon-btn rk-icon-btn--cancel"
                              title="Eliminar"
                              onClick={() => this.delete(this.props.data[0].id)}
                            >
                              <i className="fas fa-trash-alt"></i>
                            </button>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-8 mb-4">
                      <Comments
                        nameModule={"hola"}
                        usuario={this.props.usuario}
                        dataCommets={this.state.dataCommets}
                        loadComments={this.loadDataComments}
                        formValuesComments={this.state.formValuesComments}
                        HandleChangeComment={this.HandleChangeComment}
                        clearValuesComment={this.clearValuesComment}
                      />
                    </div>
                  </div>
                )}

                {this.props.califications_date.length >= 2 && (
                  <div className="rk-table-card" style={{ marginTop: 20, padding: "14px 12px 4px" }}>
                    <Chart
                      califications_date={this.props.califications_date}
                    />
                  </div>
                )}

                <h3 style={{ marginTop: "24px" }}>Historial</h3>
                <hr />

                {this.props.data.length <= 1 && (
                  <div className="rk-panel-empty" style={{ padding: "36px 16px" }}>
                    <i className="fas fa-chart-line"></i>
                    <p>Aún no hay historial. Crea más evaluaciones para ver la evolución del cumplimiento.</p>
                  </div>
                )}

                <div className="row history mt-2">
                  {this.props.data.map((accion, index) =>
                    this.props.data[0].id != accion.id ? (
                      <div className="col-md-3 mb-3" key={accion.id}>
                        <div className="rk-npr" style={{ height: "100%" }}>
                          <div className="rk-npr__label">{accion.date_score}</div>
                          <div
                            className="rk-npr__value"
                            style={{ color: this.getColor(accion.score != null ? accion.score : 0) }}
                          >
                            {accion.score != null ? accion.score : 0}
                          </div>
                          <div style={{ fontSize: "12px", color: "#64748b", marginBottom: "12px" }}>Nota de cumplimiento</div>

                          <div className="rk-inline-actions" style={{ justifyContent: "center", flexWrap: "wrap", gap: "8px" }}>
                            <a
                              href={`/health/normativity_scores/${accion.id}`}
                              target="_blank"
                              className="rk-inline-btn"
                              data-turbolinks="true"
                            >
                              <i className="fas fa-eye"></i> Ver
                            </a>

                            {(this.props.estados.editar || this.props.estados.eliminar) && (
                              <React.Fragment>
                                {this.props.estados.editar && (
                                  <button
                                    type="button"
                                    className="rk-icon-btn"
                                    title="Editar"
                                    onClick={() => this.editCalification(accion)}
                                  >
                                    <i className="fas fa-pencil-alt"></i>
                                  </button>
                                )}

                                {this.props.estados.eliminar && (
                                  <button
                                    type="button"
                                    className="rk-icon-btn rk-icon-btn--cancel"
                                    title="Eliminar"
                                    onClick={() => this.delete(accion.id)}
                                  >
                                    <i className="fas fa-trash-alt"></i>
                                  </button>
                                )}
                              </React.Fragment>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )
                  )}
                </div>
              </React.Fragment>
            ) : (
              <div className="rk-empty">
                <img
                  style={{ width: "70px" }}
                  src="https://mybc1.s3.amazonaws.com/uploads/rseguimiento/evidencia/579/geekmejoraapp.png"
                />
                <p>
                  No has realizado la primera calificación<br />
                  <span>¡ Hazlo ahora y mira como esta la norma !</span>
                </p>
              </div>
            )
          ) : (
            <div className="col-md-12 text-center">
              <Preloader />
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default Show;

